<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 35vw">
      <div class="modal-header">
        <h5 class="modal-title">🔄 Transfer Funds</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label>Source Account:</label>
          <input type="text" :value="current_account_name" disabled />
        </div>

        <div class="form-group">
          <label>Destination Account:</label>
          <select v-model="destination_account_id">
            <option disabled value="">-- Select Destination Account --</option>
            <option
              v-for="acc in all_accounts"
              :key="acc.account_id"
              :value="acc.account_id"
              :disabled="acc.account_id == account_id"
            >
              {{ acc.account_name }} (ID: {{ acc.account_id }})
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Amount (Ksh.):</label>
          <input type="number" v-model="amount" placeholder="Enter amount" />
        </div>

        <div class="form-group">
          <label>Note (optional):</label>
          <textarea
            v-model="note"
            rows="3"
            placeholder="Remarks or description"
          ></textarea>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="action-button" @click="submitTransfer">
          Transfer
        </button>
        <button type="button" class="cancel-button" @click="closeModal">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "TransferFundsModal",
  props: {
    account_id: {
      type: String,
      required: true,
    },
    // accounts: {
    //   type: Array,
    //   required: true,
    // },
  },
  data() {
    return {
      all_accounts: [],
      destination_account_id: "",
      amount: "",
      note: "",
      current_account_name: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-funds-transfer-modal");
    },
    async fetchAccountDetails() {
      this.loading = true;

      var all_req_body = {};
      const all_url = `get_all_company_accounts`;
      const all_res = await generalApiRequest(all_url, "GET", all_req_body, 1);
      this.all_accounts = all_res.data;
      console.log(all_res.data);
      if (all_res.data) {
        all_res.data.forEach((element) => {
          if (element.account_id == this.account_id) {
            this.current_account_name = element.account_name;
            console.log(element.account_name);
          }
        });
      }

      this.loading = false;
    },
    submitTransfer() {
      if (!this.destination_account_id) {
        alert("Please select a destination account.");
        return;
      }
      if (!this.amount || this.amount <= 0) {
        alert("Please enter a valid transfer amount.");
        return;
      }

      this.$emit("transfer", {
        source_account_id: this.account_id,
        destination_account_id: this.destination_account_id,
        amount: this.amount,
        note: this.note,
      });

      this.closeModal();
    },
  },
  mounted() {
    this.fetchAccountDetails();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 50%;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

input[type="number"],
input[type="text"],
textarea,
select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.action-button {
  padding: 10px 20px;
  background: #009688;
  border: none;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
}

.action-button:hover {
  background: #00796b;
}

.cancel-button {
  padding: 10px 20px;
  background: #e53935;
  border: none;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-button:hover {
  background: #c62828;
}
</style>
